import { Title, MSection, MnemoLoading, BoxSuccess, BoxDanger } from "components/misc";
import { ROUTES } from "const";
import { Icon } from "design-react-kit";
import { digcompService, learningService, networkErrorHelper } from "libs";
import React, { Component } from "react";
import { NavLink, withRouter } from 'react-router-dom';

class DIGCOMPLesson extends Component {

    state = {
        loading: true,
        loadingError: false,
        isEnabled: 0,
        course: 0,
        rCode: ''
    };

    goBack() {
        window.history.back();
    }

    componentDidMount() {

        const { rCode } = this.props.match.params;
        this.loadRemote(rCode);
    }

    loadRemote(rCode) {

        learningService
            .courseDashboard(rCode)
            .then(({ data }) => {

                const { course, userCourse } = data.payload;
                this.setState({ course, userCourse });

                digcompService.getDIGCOMPCodes(rCode)
                    .then(({ data }) => {
                        const codes = data.payload;
                        this.setState({ loading: false, loadingError: false, codes, rCode });
                    })
                    .catch(error => {
                        networkErrorHelper.notify(error);
                        this.setState({ loading: false, loadingError: true });
                    });

            })
            .catch(error => {

                if (!networkErrorHelper.is404(error)) {
                    networkErrorHelper.notify(error);
                }

                this.setState({ loading: false, loadingError: true });
            });
    }

    render() {

        const { rCode } = this.props.match.params;
        const { loading, codes, course } = this.state;

        if (loading) return (<MnemoLoading></MnemoLoading>);

        return (
            <>
                <NavLink to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`} className="mx-5 btn btn-outline-primary float-right"><Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO</NavLink>
                {(course.code === 'DIGCOMP2_2') ? (<>
                    <Title >Materiale didattico</Title>
                    <MSection className="mt-2">
                        <a href="https://www.formazionedocenti.it/files/corsi/DIGCOM/Manuale_per_Esame_DigComp_2_2.pdf">Clicca qui per scaricare il materiale didattico</a>
                        <hr />
                        <p>Per qualsiasi informazione su tale procedura o su aspetti tecnici relativi all’utilizzo della piattaforma
                            telematica, potrà contattare il personale addetto a tale servizio dal Lunedì al Venerdì dalle ore 09:00 alle
                            ore 13:00 e dalle ore 14:30 alle ore 18:00 solo ed esclusivamente al seguente numero di telefono: 3664140604
                            o inviare e-mail a: <a href="mailto:supporto@formazionedocenti.it">supporto@formazionedocenti.it</a>.</p>
                        <hr />
                    </MSection>
                </>) : (<>
                    <MSection>
                        <h6><a href="https://app.micertificoicdl.it/login" target="_blank" rel="noopener noreferrer"  >Clicca qui per accedere alla piattaforma AICA “micertificoicdl.it”</a></h6>
                        <footer className="blockquote-footer">https://app.micertificoicdl.it/login</footer>
                    </MSection>
                    <MSection className="mt-2">
                        <h1>Istruzioni Operative</h1>
                        <p>Dopo aver cliccato sul link di accesso AICA micertificoicdl.it visualizzerà la seguente schermata (Figura 1).</p>
                        <div className="image-container">
                            <img className="image-60 mb-1" src="/img/learning/aica/aica1.png" alt="Accesso piattaforma AICA" />
                            <footer className="blockquote-footer">Figura 1. Accesso piattaforma AICA</footer>
                        </div>
                        <p>Al primo accesso è richiesto di registrarsi facendo clic sul pulsante <b>Registrati</b> (Figura 1). </p>
                        <p>La Figura 2 mostra la procedura di registrazione con l’inserimento dei dati personali e di informazioni obbligatorie per l’attivazione dell’account:</p>
                        <div className="image-container">
                            <img className="image-60 mb-1" src="/img/learning/aica/aica2.png" alt="Procedura di registrazione" />
                            <footer className="blockquote-footer">Figura 2. Procedura di registrazione</footer>
                        </div>
                        <p>Una volta cliccato su Registrati riceverà un’e-mail di conferma registrazione con l’accesso al sistema (Figura 3).</p>
                        <div className="image-container">
                            <img className="image-60 mb-1" src="/img/learning/aica/digcomp3.png" alt="Contenuti disponibili per l’attivazione" />
                            <footer className="blockquote-footer">Figura 3. Contenuti disponibili per l’attivazione</footer>
                        </div>

                        <p>
                            Il codice di seguito riportato Le permetterà di attivare il modulo DIGCOMPEDU - Livelli da A1 a B2 e di approfondire i contenuti (vedi Figura 4):</p>
                        {(codes) && (
                            <BoxSuccess>Codice Attivazione: {codes[0]}</BoxSuccess>
                        )}
                        <div className="image-container">
                            <img className="image-60 mb-1" src="/img/learning/aica/digcomp4.png" alt="Selezione ed attivazione del Corso" />
                            <footer className="blockquote-footer"> Figura 4. Modulo DigCompEdu - Livelli A1 a B2 da attivare</footer>
                        </div>
                        <BoxDanger>Le ricordiamo che per attivare il modulo DigCompEdu - Livelli A1 a B2 occorre inserire il codice fornito nella casella Riscatta questo corso dopo aver cliccato sul riquadro relativo al modulo e di cliccare, infine, su Riscatta (Figura 5). Dal momento dell’attivazione, avrà a disposizione i materiali didattici per i successivi 12 mesi.
                        </BoxDanger>
                        <div className="image-container">
                            <img className="image-60 mb-1" src="/img/learning/aica/digcomp5.png" alt="Inserimento codice di attivazione per il Corso" />
                            <footer className="blockquote-footer"> Figura 5. Attivazione Modulo DigCompEdu - Livelli A1 a B2</footer>
                        </div>
                        <p>Per qualsiasi informazione su tale procedura o su aspetti tecnici relativi all’utilizzo della piattaforma
                            telematica, potrà contattare il personale addetto a tale servizio dal Lunedì al Venerdì dalle ore 09:00 alle
                            ore 13:00 e dalle ore 14:30 alle ore 18:00 solo ed esclusivamente al seguente numero di telefono: 3664140604
                            o inviare e-mail a: <a href="mailto:supporto@formazionedocenti.it">supporto@formazionedocenti.it</a>.</p>
                        <hr />
                        <p><b>ATTENZIONE</b>: Nel caso di attivazione di moduli diversi da quello acquistato, si dovrà versare un contributo di Euro 100,00 per ogni nuovo codice di attivazione. Pertanto invitiamo a prestare la MASSIMA attenzione onde evitare spiacevoli ed onerosi errori.</p>
                    </MSection>

                </>)
                }

            </>);
    }
}

export default withRouter(DIGCOMPLesson);